// extracted by mini-css-extract-plugin
module.exports = {"bookItem":"BookSearchCompactItem_bookItem__2atGo"};